import classNames from 'classnames'
import Link from 'next/link'
import React, { useRef } from 'react'
import DropdownItem from 'react-bootstrap/DropdownItem'
import { Menu, Typeahead as BSTypeahead } from 'react-bootstrap-typeahead'

import { TribeLinkType } from '@/types/page'
import useDirectories from '@/utils/useDirectories'

import styles from './TagsTypeahead.module.scss'

type Props = {
  budgetSuffix: string
  sanitized_wo: string
  themes: TribeLinkType[]
}

const ThemesTypeahead = ({ budgetSuffix, sanitized_wo, themes }: Props) => {
  const { dir, subsubpage, subsubsubpage } = useDirectories()

  const ref = useRef<BSTypeahead<any>>(null)

  return (
    <BSTypeahead
      className={classNames(styles.typeahead, 'mt-2')}
      id='more-themes'
      options={themes.map((theme) => ({ ...theme, label: theme.value }))}
      placeholder='More Themes...'
      ref={ref}
      renderMenu={(themes, menuProps) => (
        <Menu {...menuProps}>
          {themes.map((theme) => {
            // TODO move to backend
            // divides counts for budget and expensive by 10
            const count =
              ['budget', 'expensive'].includes(subsubpage) || ['budget', 'expensive'].includes(subsubsubpage)
                ? Math.floor(theme.count / 10)
                : theme.count
            if (count === 0) return null

            return (
              <DropdownItem
                onClick={() => ref.current?.clear()}
                key={theme.value}
                as={Link}
                scroll={false}
                href={`/${dir}/${sanitized_wo}${theme['href-suffix']}${budgetSuffix}`}
              >
                <div className={styles.item}>
                  <span className='me-4'>{theme.value}</span>
                  <span>{count}</span>
                </div>
              </DropdownItem>
            )
          })}
        </Menu>
      )}
    />
  )
}

export default React.memo(ThemesTypeahead)
